import { render, staticRenderFns } from "./systemTags.vue?vue&type=template&id=0880f076&scoped=true&lang=pug"
import script from "./systemTags.vue?vue&type=script&lang=js"
export * from "./systemTags.vue?vue&type=script&lang=js"
import style1 from "./systemTags.vue?vue&type=style&index=1&id=0880f076&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0880f076",
  null
  
)

export default component.exports